'use client';

import { ComponentProps } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa6';
import { useMap } from 'react-map-gl/maplibre';
import { twMerge } from 'tailwind-merge';

import { Button } from '@/components/Button';

export type ZoomProps = ComponentProps<'div'>;

export function Zoom({ className, ...props }: ZoomProps) {
  const mapRef = useMap();

  function onZoomIn() {
    mapRef.current?.zoomIn({ duration: 500, animate: true });
  }

  function onZoomOut() {
    mapRef.current?.zoomOut({ duration: 500, animate: true });
  }

  return (
    <div
      className={twMerge(
        'absolute top-8 right-3 flex flex-col gap-2 lg:right-20',
        className,
      )}
      {...props}
    >
      <Button
        onClick={onZoomIn}
        variant="outline"
        className="rounded-full bg-white"
      >
        <FaPlus className="size-5" />
      </Button>

      <Button
        onClick={onZoomOut}
        variant="outline"
        className="rounded-full bg-white"
      >
        <FaMinus className="size-5" />
      </Button>
    </div>
  );
}
